// WS /api/events client with exponential reconnect.
import { eventsSocketUrl } from "../api";
import type { ServerEvent } from "../api/types";
import { applyServerEvent, store } from "./app";

let socket: WebSocket | null = null;
let retry = 0;
let timer: number | null = null;
let stopped = true;

function schedule(): void {
  if (stopped) return;
  const delay = Math.min(30000, 1000 * 2 ** retry);
  retry++;
  timer = window.setTimeout(connect, delay);
}

function connect(): void {
  if (stopped) return;
  try {
    socket = new WebSocket(eventsSocketUrl());
  } catch {
    schedule();
    return;
  }
  socket.onopen = () => {
    retry = 0;
    store.set({ eventsConnected: true });
  };
  socket.onmessage = (msg) => {
    try {
      const ev = JSON.parse(String(msg.data)) as ServerEvent;
      if (ev && typeof ev === "object" && "type" in ev) applyServerEvent(ev);
    } catch {
      /* ignore malformed */
    }
  };
  socket.onclose = () => {
    store.set({ eventsConnected: false });
    socket = null;
    schedule();
  };
  socket.onerror = () => {
    socket?.close();
  };
}

export function startEvents(): void {
  if (!stopped) return;
  stopped = false;
  retry = 0;
  connect();
}

export function stopEvents(): void {
  stopped = true;
  if (timer !== null) window.clearTimeout(timer);
  timer = null;
  if (socket) {
    socket.onclose = null;
    socket.close();
    socket = null;
  }
  store.set({ eventsConnected: false });
}
